import { Modal } from "bootstrap";

import {
    forwardRef,
    useImperativeHandle,
    useRef,
    useState,
} from "react";

import Select from "react-select";

import {
    useForm,
    Controller,
} from "react-hook-form";

import { toast } from "react-toastify";


import * as b2bleadService from "../../Services/b2bleadService";

const B2BBulkAssignModal = forwardRef(
    (props, ref) => {

        const {
            selectedLeads,
            setSelectedLeads,
            getLeadData,
        } = props;

        const {
            control,
            handleSubmit,
            reset,
            formState: { errors },
        } = useForm({
            mode: "onSubmit",
        });

        const modalRef = useRef(null);

        const bsModal = useRef(null);

        // STATES
        const [employees, setEmployees] =
            useState([]);

        const [selectedEmployee, setSelectedEmployee] =
            useState(null);

        const [loadData, setLoadData] =
            useState({});

        const [loadPercentage, setLoadPercentage] =
            useState({});

        const [loader, setLoader] =
            useState(false);

        const [submitLoader, setSubmitLoader] =
            useState(false);

        // RESET + CLOSE
        const handleClose = () => {

            reset();

            setSelectedEmployee(null);

            setLoadData({});

            setLoadPercentage({});

            bsModal.current?.hide();

        };

        // MODAL HANDLE
        useImperativeHandle(ref, () => ({

            toggle() {

                if (!bsModal.current) {

                    bsModal.current =
                        new Modal(
                            modalRef.current
                        );

                }

                bsModal.current.show();

                getEmployeeData();

            },

            close() {

                handleClose();

            },

        }));

        // GET EMPLOYEES
        const getEmployeeData = () => {

            b2bleadService

                .getEmployees()

                .then((res) => {

                    if (
                        res?.data?.status ===
                        "success"
                    ) {

                        const employeeOptions =
                            res?.data?.data?.map(
                                (item) => ({

                                    label:
                                        `${item.firstName} ${item.lastName}`,

                                    value:
                                        item.id,

                                })
                            );

                        setEmployees(
                            employeeOptions
                        );

                    }

                })

                .catch((err) => {

                    console.log(
                        "EMPLOYEE ERROR",
                        err
                    );

                });

        };

        // EMPLOYEE LOAD
        // const getEmployeeLoad = (
        //     empId
        // ) => {

        //     setLoader(true);

        //     b2cleadService

        //         .getEmployeeLeadLoad(
        //             empId
        //         )

        //         .then((res) => {

        //             if (
        //                 res?.data?.status ===
        //                 "success"
        //             ) {

        //                 setLoadData(
        //                     res?.data?.data
        //                 );

        //                 setLoadPercentage(
        //                     res?.data?.data
        //                         ?.employee
        //                 );

        //             }

        //         })

        //         .catch((err) => {

        //             console.log(
        //                 "LOAD ERROR",
        //                 err
        //             );

        //         })

        //         .finally(() => {

        //             setLoader(false);

        //         });

        // };

        const getEmployeeLoad = (empId) => {

            setLoader(true);

            b2bleadService
                .getEmployeeLeadLoad(empId)

                .then((res) => {

                    console.log(
                        "LOAD RESPONSE",
                        res?.data
                    );

                    const responseData =
                        res?.data?.data || {};

                    setLoadData({
                        pendingPercentage:
                            responseData?.pendingPercentage || 0,

                        totalLead:
                            responseData?.totalLead || 0,

                        totalPendingLead:
                            responseData?.totalPendingLead || 0,
                    });

                    setLoadPercentage(
                        responseData?.employee || {}
                    );

                })

                .catch((err) => {

                    console.log(
                        "LOAD ERROR",
                        err
                    );

                })

                .finally(() => {

                    setLoader(false);

                });
        };

        // SUBMIT
        const onSubmit = (data) => {

            setSubmitLoader(true);

            const formData =
                new FormData();

            // EMPLOYEE ID
            formData.append(
                "empId",
                data?.employee?.value
            );

            // LEAD IDS
            formData.append(
                "leadsId",
                JSON.stringify(
                    selectedLeads
                )
            );

            b2bleadService

                .bulkAssignLead(
                    formData
                )

                .then((res) => {

                    if (res?.data?.status === "success") {
                        toast.success(res?.data?.message);
                        // RESET SELECTED CHECKBOX
                        setSelectedLeads([]);

                        handleClose();

                        getLeadData();

                    }

                })

                .catch((err) => {

                    console.log(
                        "ASSIGN ERROR",
                        err
                    );

                    toast.error(
                        "Failed To Assign Lead"
                    );

                })

                .finally(() => {

                    setSubmitLoader(false);

                });

        };

        return (

            <div
                className="modal fade"
                ref={modalRef}
                tabIndex="-1"
                aria-hidden="true"
                style={{
                    background:
                        "rgba(15,23,42,0.55)",

                    backdropFilter:
                        "blur(5px)",
                }}
            >

                <div
                    className="modal-dialog modal-lg modal-dialog-centered "
                    style={{
                        maxWidth: "95vw",
                        width: "95vw",
                        margin: "10px auto",
                    }}
                >

                    <div
                        className="modal-content border-0 rounded-4"
                        style={{
                            width: "100%",
                        }}
                    >

                        {/* HEADER */}
                        <div
                            className="modal-header border-0 text-white"
                            style={{
                                background:
                                    "rgb(94, 44, 158)",
                            }}
                        >

                            <div>

                                {/* <h4 className="modal-title fw-bold text-dark mb-1">

                                    Bulk Assign

                                </h4> */}

                                <p className="mb-0 small opacity-75">

                                    Assign selected leads to employee

                                </p>

                            </div>

                            <button
                                type="button"
                                className="btn btn-light rounded-circle position-absolute"
                                style={{
                                    top: "10px",
                                    right: "18px",
                                    width: "38px",
                                    height: "38px",
                                }}
                                onClick={
                                    handleClose
                                }
                            >

                                <i className="fa fa-times"></i>

                            </button>

                        </div>

                        {/* FORM */}
                        <form
                            onSubmit={handleSubmit(
                                onSubmit
                            )}
                        >

                            {/* BODY */}
                            <div className="modal-body p-4">

                                <div className="row g-4">

                                    {/* ASSIGN */}
                                    <div className="col-md-12">

                                        <label className="form-label fw-semibold">

                                            Assign Employee

                                            <span className="text-danger ms-1">
                                                *
                                            </span>

                                        </label>

                                        <Controller
                                            name="employee"
                                            control={
                                                control
                                            }
                                            rules={{
                                                required:
                                                    "Please select atleast one employee",
                                            }}
                                            render={({
                                                field,
                                            }) => (

                                                <Select
                                                    {...field}
                                                    placeholder="Select Employee"
                                                    options={
                                                        employees
                                                    }
                                                    className="react-select-container"
                                                    classNamePrefix="react-select"
                                                    value={
                                                        field.value || null
                                                    }
                                                    isClearable
                                                    isSearchable
                                                    onChange={(
                                                        selected
                                                    ) => {

                                                        field.onChange(
                                                            selected
                                                        );

                                                        setSelectedEmployee(
                                                            selected
                                                        );

                                                        if (
                                                            selected?.value
                                                        ) {

                                                            getEmployeeLoad(
                                                                selected?.value
                                                            );

                                                        } else {

                                                            setLoadData(
                                                                {}
                                                            );

                                                            setLoadPercentage(
                                                                {}
                                                            );

                                                        }

                                                    }}
                                                />

                                            )}
                                        />

                                        {errors.employee && (

                                            <small className="text-danger fw-semibold">

                                                {
                                                    errors
                                                        .employee
                                                        .message
                                                }

                                            </small>

                                        )}

                                    </div>

                                    {/* CURRENT LOAD */}
                                    <div className="col-md-6">

                                        <div
                                            className="border rounded-4 p-4 h-100"
                                            style={{
                                                background:
                                                    "#f8fafc",
                                            }}
                                        >

                                            <p className="text-muted small mb-2">

                                                Current Lead Load

                                            </p>

                                            <h2 className="fw-bold text-primary mb-0">

                                                {loader
                                                    ? "..."
                                                    : `${loadData?.pendingPercentage || 0}%`}

                                            </h2>

                                        </div>

                                    </div>

                                    {/* ALLOWED LOAD */}
                                    <div className="col-md-6">

                                        <div
                                            className="border rounded-4 p-4 h-100"
                                            style={{
                                                background:
                                                    "#f8fafc",
                                            }}
                                        >

                                            <p className="text-muted small mb-2">

                                                Allowed Lead Limit

                                            </p>

                                            <h2 className="fw-bold text-success mb-0">

                                                {loader
                                                    ? "..."
                                                    : `${loadPercentage?.leadLoadPercentage || 0}%`}

                                            </h2>

                                        </div>

                                    </div>

                                    {/* WARNING */}
                                    {loadData?.pendingPercentage >
                                        loadPercentage?.leadLoadPercentage && (

                                            <div className="col-md-12">

                                                <div className="alert alert-danger rounded-4 border-0 mb-0">

                                                    <i className="fa fa-warning me-2"></i>

                                                    Employee is overloaded with{" "}

                                                    <strong>
                                                        {
                                                            loadData?.pendingPercentage
                                                        }%
                                                    </strong>{" "}

                                                    pending leads.

                                                </div>

                                            </div>

                                        )}

                                </div>

                            </div>

                            {/* FOOTER */}
                            <div className="modal-footer border-0 px-4 pb-4">

                                <button
                                    type="button"
                                    className="btn btn-sm btn-light border rounded-pill px-4 fw-semibold"
                                    onClick={
                                        handleClose
                                    }
                                >

                                    Close

                                </button>

                                <button
                                    type="submit"
                                    className="btn btn-sm btn-primary rounded-pill px-4 fw-semibold shadow-sm"
                                    disabled={
                                        submitLoader
                                    }
                                >

                                    {submitLoader
                                        ? "Assigning..."
                                        : "Save"}

                                </button>

                            </div>

                        </form>

                    </div>

                </div>

            </div>

        );

    }
);

export default B2BBulkAssignModal;